export const retryDefault = {
  min: 0,
  max: 5,
};

export const retryAuth = {
  min: 0,
  max: 5,
};

export const loginTimeouts = {
  min: 5,
  max: 60,
};

export const sessionTimeouts = {
  min: 5,
  max: 600,
};

export const authenticationTimeouts = {
  min: 5,
  max: 600,
};

export const commandTimeoutsMinutes = {
  min: 1,
  max: 300,
};

export const cliLimitSessions = {
  min: 1,
};

export const tacacsRetry = {
  min: 0,
  max: 3,
};

export const tacacsDelay = {
  min: 500,
  max: 5000,
};
